<!--
 * @Description: 用户端关于页面
 * @Author: 蒙川
 * @Date: 2019-03-15 09:04:37
 * @LastEditors: 蒙川
 * @LastEditTime: 2019-10-15 09:31:06
 -->
<template>
  <div class="about-protocol-container">
    <!-- <div class="about-content" v-html="content"></div> -->
    <ul class="list">
      <li v-for="(item, index) in list" :key="index" @click="linkTo(index)">
        <div v-text="item"></div>
        <img src="../assets/image/arrow_icon.png" alt="">
      </li>
    </ul>
    <div class="footer">
      <div v-text="right"></div>
      <div v-text="company"></div>
    </div>
  </div>
</template>
<script>
import api from '@/script/util'
export default {
  data () {
    return {
      list: [
        '关于',
        '软件许可协议',
        '功能介绍'
      ],
      company: '',
      right: ''
    }
  },
  computed: {
    isAndroid () {
      let agent = navigator.userAgent.toLowerCase()
      return agent.indexOf('android') !== -1
    }
  },
  created () {
    if (!this.isAndroid) {
      this.list.push('特别说明')
    }
    this.getAppInfo()
  },
  methods: {
    async getAppInfo () {
      let url = 'appInfo/getAppInfoByAppId'
      const data = await api.axios.get(url)
      if (data.status === 100) {
        this.company = data.data.companyName
        this.right = data.data.copyRight
      }
    },
    linkTo (index) {
      if (index === 0) {
        this.$router.push({
          name: 'protocol',
          query: {
            redirect: 1,
            ...this.$route.query
          }
        })
      } else if (index === 1) {
        let query = {...this.$route.query}
        query.type = this.isAndroid ? 29 : 30
        this.$router.push({
          name: 'protocol',
          query: {
            ...query
          }
        })
      } else if (index === 2) {
        this.$router.push({
          name: 'featureIntro',
          query: {
            ...this.$route.query
          }
        })
      } else if (index === 3) {
        this.$router.push({
          name: 'specialInstructions'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .about-protocol-container {
    height: 100%;
    background-color: rgb(240, 242, 242);
    .about-content {
      background-color: #fff;
      padding: 15px;
      p {
        margin: 10px 0;
        word-break: break-all;
      }
    }
    .footer {
      font-size: 12px;
      color: #aaa;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: absolute;
      width: 100%;
      bottom: 0;
    }
  }
  .list {
    background-color: #fff;
    li {
      font-size: 15px;
      display: flex;
      height: 44px;
      align-items: center;
      padding-left: 12px;
      padding-right: 12px;
      justify-content: space-between;
      border-bottom: 1px solid #e0e0e0;
      img {
        height: 14px;
      }
    }
    
  }
</style>
<style lang="scss">
.content img {
  display: block;
  text-align: center;
  max-width: 100%;
  cursor: pointer;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// aboutProtocol.vue?0e1c9186